import type { MenuBlock } from '@ps/web-martech-cms-types/SiteFooter';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';

import Arrow from '@swf/core/assets/icons/arrow.svg';

import useGeoVisibility from '../../../CMSContainer/hooks/useGeoVisibility';

import styles from './FooterMenu.scss';

const FooterMenu: React.FC<MenuBlock> = ({ links, title, visibility_rules: visibilityRules }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible] = useGeoVisibility(visibilityRules || []);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={classNames({
        [styles.footerMenu]: true,
        [styles.open]: isOpen || !title
      })}
    >
      {title && (
        <h3 className={styles.heading} onClick={() => setIsOpen(!isOpen)}>
          {title}
          <Arrow className={styles.arrow} />
        </h3>
      )}
      <ul className={styles.footerMenuLinks}>
        {links.map((link, i) => (
          <li key={i} className={styles.footerMenuLink}>
            <Link href={link.url || ''} isCrossPlatform>
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterMenu;
